import { Transaction } from './types';

/**
 * The notice explains an amount the system adjusted. A tile the client picked is their own choice
 * and needs no explanation; an absent source means the server does not say, and the notice stays.
 */
export const showsAmountChangeNotice = (
  transaction: Pick<Transaction, 'amountChanged' | 'amountChangeSource'>,
): boolean => transaction.amountChanged === true && transaction.amountChangeSource !== 'variant';
